module.exports = {
	"/shop/merino-round-cushion/": {
		"id": 2,
		"name": "Merino Round Cushion",
		"price": 50,
		"path": "/shop/merino-round-cushion/",
		"thumbnail": "/images/products/merino-round-cushion/06.jpg",
		"category": "home",
		"type": "round-cushion",
		"gallery": {
			"1": "/images/products/merino-round-cushion/03.jpg",
			"2": "/images/products/merino-round-cushion/01.jpg",
			"3": "/images/products/merino-round-cushion/02.jpg",
			"4": "/images/products/merino-round-cushion/04.jpg",
			"5": "/images/products/merino-round-cushion/05.jpg",
			"6": "/images/products/merino-round-cushion/06.jpg"
		},
		"tabs": {
			"0": {
				"title": "Samples",
				"content": "some samples text"
			},
			"1": {
				"title": "Extras",
				"content": "some description about available extras for this products"
			},
			"2": {
				"title": "care tips",
				"content": "how to care about products"
			}
		},
		"description": {
			"short": "Extremely soft and cozy, UK handicraft, luxury Round Cushion made from pure merino wool!",
			"long": "<p>Beautifully crochet round cushion will be a great addition to your living room or bedroom. Made from 100% super chunky Merino Wool. These luxury products come complete with hollowfibre filling(let us know if you want different one). Transform your sofa or bed in the most cozy place in the world by adding some cushions and bedcover from merino wool. We can guarantee that everyone in the room will stare at it!</p><p class='CalipsyContent-title'>Chose version premium(~25microns) or deluxe(~18.5microns) if you want feel extreme cozy! Also, there is 25 colors and shades, 4 basic sizes and 2 patterns to chose from.</p><p>If you need any different size, just give us a shout directly on email or via social media.</p>"
		},
		"weight": 1000,
		"preset": {
			"material": "premium",
			"color": "ecru",
			"size": "16x16inches",
			"pattern": "sunshine"
		},
		"variants": {
			"material": {
				"premium": 0,
				"deluxe": 0
			},
			"color": {
				"ecru": "0|0",
				"mustard": "0|0",
				"clementine": "0|0",
				"pumpkin": "0|0",
				"poppy": "0|0",
				"scarlet": "0|0",
				"elderberry": "0|0",
				"salmon": "0|0",
				"barbie": "0|0",
				"hot pink": "0|0",
				"chocolate": "0|0",
				"candyfloss": "0|0",
				"damson": "0|0",
				"lime": "0|0",
				"gooseberry": "0|0",
				"olive": "0|0",
				"moss": "0|0",
				"dream": "0|0",
				"spearmint": "0|0",
				"royal": "0|0",
				"navy": "0|0",
				"midnight": "0|0",
				"seal": "0|0",
				"grey": "0|0",
				"black": "0|0"
			},
			"size": {
				"16x16inches": "0|25",
				"18x18inches": "5|35",
				"20x20inches": "10|45",
				"22x22inches": "15|55"
			},
			"pattern": {
				"sunshine": "0|0",
				"braid": "0|0"
			}
		}
	},
	"/shop/merino-chunky-blanket/": {
		"id": 3,
		"name": "Merino Chunky Blanket",
		"price": 45,
		"path": "/shop/merino-chunky-blanket/",
		"thumbnail": "/images/products/merino-chunky-blanket/06.jpg",
		"category": "home",
		"type": "blanket",
		"gallery": {
			"1": "/images/products/merino-chunky-blanket/01.jpg",
			"2": "/images/products/merino-chunky-blanket/02.jpg",
			"3": "/images/products/merino-chunky-blanket/03.jpg",
			"4": "/images/products/merino-chunky-blanket/04.jpg",
			"5": "/images/products/merino-chunky-blanket/05.jpg",
			"6": "/images/products/merino-chunky-blanket/06.jpg",
			"7": "/images/products/merino-chunky-blanket/07.jpg"
		},
		"tabs": {
			"0": {
				"title": "Samples",
				"content": "some samples text"
			},
			"1": {
				"title": "Extras",
				"content": "some description about available extras for this products"
			},
			"2": {
				"title": "care tips",
				"content": "how to care about products"
			}
		},
		"description": {
			"short": "Extremely soft and cozy, UK handicraft, luxury Blanket made from pure merino wool!",
			"long": "<p>A merino wool blanket is the perfect solution for warming up on cooler days, alongside a good movie, in the comfort of your home. They have a wonderful and unique look that will highlight the decoration of your home. You will find out everyone will be delighted!</p><p>The blanket is an extremely luxury and beautiful product, which will bring more style and comfort into your home. Also, it's perfect gift for any occasion. </p><p class='CalipsyContent-title'>Chose version premium(~25microns) or deluxe(~18.5microns) if you want feel extreme cozy! Also, there is 25 colors and shades, 9 basic sizes and 3 patterns to chose from.</p><p>If you need any different size, just give us a shout directly on email or via social media.</p>"
		},
		"weight": 5000,
		"preset": {
			"material": "premium",
			"color": "ecru",
			"size": "25x35inches",
			"pattern": "classic"
		},
		"variants": {
			"material": {
				"premium": 0,
				"deluxe": 0
			},
			"color": {
				"ecru": "0|0",
				"mustard": "0|0",
				"clementine": "0|0",
				"pumpkin": "0|0",
				"poppy": "0|0",
				"scarlet": "0|0",
				"elderberry": "0|0",
				"salmon": "0|0",
				"barbie": "0|0",
				"hot pink": "0|0",
				"chocolate": "0|0",
				"candyfloss": "0|0",
				"damson": "0|0",
				"lime": "0|0",
				"gooseberry": "0|0",
				"olive": "0|0",
				"moss": "0|0",
				"dream": "0|0",
				"spearmint": "0|0",
				"royal": "0|0",
				"navy": "0|0",
				"midnight": "0|0",
				"seal": "0|0",
				"grey": "0|0",
				"black": "0|0"
			},
			"size": {
				"25x35inches": "0|25",
				"30x50inches": "70|165",
				"40x60inches": "105|300",
				"50x70inches": "150|375",
				"60x80inches": "200|525",
				"80x80inches": "305|660",
				"80x100inches": "500|980",
				"90x90inches": "500|980",
				"100x100inches": "680|1400"
			},
			"pattern": {
				"classic": "0|0",
				"chess": "0|0",
				"braid": "0|0",
				"striped": "0|0"
			}
		}
	},
	"/shop/merino-classic-scarf/": {
		"id": 4,
		"name": "Merino Classic Scarf",
		"price": 45,
		"path": "/shop/merino-classic-scarf/",
		"thumbnail": "/images/products/merino-classic-scarf/04.jpg",
		"category": "knitwear",
		"type": "classic-scarf",
		"gallery": {
			"1": "/images/products/merino-classic-scarf/01.jpg",
			"2": "/images/products/merino-classic-scarf/02.jpg",
			"3": "/images/products/merino-classic-scarf/03.jpg",
			"4": "/images/products/merino-classic-scarf/04.jpg"
		},
		"tabs": {
			"0": {
				"title": "Samples",
				"content": "some samples text"
			},
			"1": {
				"title": "Extras",
				"content": "some description about available extras for this products"
			},
			"2": {
				"title": "care tips",
				"content": "how to care about products"
			}
		},
		"description": {
			"short": "Extremely soft and cozy, UK handicraft, luxury Classic Scarf made from pure merino wool!",
			"long": "<p>100% pure merino wool, soft and warm, classic scarf. It provides such great comfort that you will be constantly hugging it! Besides it's breathable and natural. This scarf will keep you warm no matter the weather. Also, it will be a really eye catching part of your outfit! It looks great on both, a woman, and a man.</p><p class='CalipsyContent-title'>Chose version premium(~25microns) or deluxe(~18.5microns) if you want feel extreme cozy! Also, there is 25 colors and shades and 6 basic sizes to chose from.</p><p>If you need any different size, just give us a shout directly on email or via social media.</p>"
		},
		"weight": 1000,
		"preset": {
			"material": "premium",
			"color": "ecru",
			"size": "45x5inches",
			"pattern": "classic"
		},
		"variants": {
			"material": {
				"premium": 0,
				"deluxe": 0
			},
			"color": {
				"ecru": "0|0",
				"mustard": "0|0",
				"clementine": "0|0",
				"pumpkin": "0|0",
				"poppy": "0|0",
				"scarlet": "0|0",
				"elderberry": "0|0",
				"salmon": "0|0",
				"barbie": "0|0",
				"hot pink": "0|0",
				"chocolate": "0|0",
				"candyfloss": "0|0",
				"damson": "0|0",
				"lime": "0|0",
				"gooseberry": "0|0",
				"olive": "0|0",
				"moss": "0|0",
				"dream": "0|0",
				"spearmint": "0|0",
				"royal": "0|0",
				"navy": "0|0",
				"midnight": "0|0",
				"seal": "0|0",
				"grey": "0|0",
				"black": "0|0"
			},
			"size": {
				"45x5inches": "0|10",
				"55x5inches": "5|20",
				"65x5inches": "10|30",
				"75x5inches": "15|40",
				"85x5inches": "20|50",
				"95x5inches": "25|60"
			},
			"pattern": {
				"classic": "0|0"
			}
		}
	},
	"/shop/merino-super-chunky-scarf/": {
		"id": 5,
		"name": "Merino Super Chunky Scarf",
		"price": 60,
		"path": "/shop/merino-super-chunky-scarf/",
		"thumbnail": "/images/products/merino-super-chunky-scarf/01.jpg",
		"category": "knitwear",
		"type": "super-chunky-scarf",
		"gallery": {
			"1": "/images/products/merino-super-chunky-scarf/01.jpg",
			"2": "/images/products/merino-super-chunky-scarf/02.jpg",
			"3": "/images/products/merino-super-chunky-scarf/03.jpg",
			"4": "/images/products/merino-super-chunky-scarf/04.jpg",
			"5": "/images/products/merino-super-chunky-scarf/05.jpg",
			"6": "/images/products/merino-super-chunky-scarf/06.jpg",
			"7": "/images/products/merino-super-chunky-scarf/07.jpg"
		},
		"tabs": {
			"0": {
				"title": "Samples",
				"content": "some samples text"
			},
			"1": {
				"title": "Extras",
				"content": "some description about available extras for this products"
			},
			"2": {
				"title": "care tips",
				"content": "how to care about products"
			}
		},
		"description": {
			"short": "Extremely soft and cozy, UK handicraft, luxury Chunky Scarf made from pure merino wool!",
			"long": "<p>Super chunky scarf made from 100% pure merino wool. It's e xtremely cozy and will keeps you warm all the time. It provides such great comfort that you will be constantly hugging it! Besides it's breathable and natural. This scarf will keep you warm no matter the weather. It also will be a really eye catching part of your outfit! It looks great on both, a woman, and a man. Great gift for your love ones.</p><p class='CalipsyContent-title'>Chose version premium(~25microns) or deluxe(~18.5microns) if you want feel extreme cozy! Also, there is 25 colors and shades and 6 basic sizes to chose from.</p><p>If you need any different size, just give us a shout directly on email or via social media.</p>"
		},
		"weight": 1000,
		"preset": {
			"material": "premium",
			"color": "ecru",
			"size": "45x10inches",
			"pattern": "classic"
		},
		"variants": {
			"material": {
				"premium": 0,
				"deluxe": 0
			},
			"color": {
				"ecru": "0|0",
				"mustard": "0|0",
				"clementine": "0|0",
				"pumpkin": "0|0",
				"poppy": "0|0",
				"scarlet": "0|0",
				"elderberry": "0|0",
				"salmon": "0|0",
				"barbie": "0|0",
				"hot pink": "0|0",
				"chocolate": "0|0",
				"candyfloss": "0|0",
				"damson": "0|0",
				"lime": "0|0",
				"gooseberry": "0|0",
				"olive": "0|0",
				"moss": "0|0",
				"dream": "0|0",
				"spearmint": "0|0",
				"royal": "0|0",
				"navy": "0|0",
				"midnight": "0|0",
				"seal": "0|0",
				"grey": "0|0",
				"black": "0|0"
			},
			"size": {
				"45x10inches": "0|15",
				"55x10inches": "10|30",
				"65x10inches": "20|45",
				"75x10inches": "30|60",
				"85x10inches": "40|75",
				"95x10inches": "50|90"
			},
			"pattern": {
				"classic": "0|0"
			}
		}
	},
	"/shop/merino-pom-pom-beanie/": {
		"id": 6,
		"name": "Merino Pom-Pom Beanie",
		"price": 60,
		"path": "/shop/merino-pom-pom-beanie/",
		"thumbnail": "/images/products/merino-pom-pom-beanie/01.jpg",
		"category": "knitwear",
		"type": "pom-pom-beanie",
		"gallery": {
			"1": "/images/products/merino-pom-pom-beanie/01.jpg",
			"2": "/images/products/merino-pom-pom-beanie/02.jpg",
			"3": "/images/products/merino-pom-pom-beanie/03.jpg",
			"4": "/images/products/merino-pom-pom-beanie/04.jpg",
			"5": "/images/products/merino-pom-pom-beanie/05.jpg"
		},
		"tabs": {
			"0": {
				"title": "Samples",
				"content": "some samples text"
			},
			"1": {
				"title": "Extras",
				"content": "some description about available extras for this products"
			},
			"2": {
				"title": "care tips",
				"content": "how to care about products"
			}
		},
		"description": {
			"short": "Extremely soft and cozy, UK handicraft, luxury Pom-Pom Beanie made from pure merino wool!",
			"long": "<p>A luxurious, chunky knit handmade beanie, finished with unique pom-pom. It provides very good protection against cold, and due to its delicacy it ensures superior comfort of use. I can bet you've never wear more comfortable beanie! Make even better impression and combine it with any kind of scarf, and you will definitely be noticed!</p><p>Every beanie is tailored specially for you, so please remember to send us head measurement, or let us know if you want us to made it in 'one-size-fits-all' option.</p><p class='CalipsyContent-title'>Chose version premium(~25microns) or deluxe(~18.5microns) if you want feel extreme cozy! Also, there is 25 colors to chose from.</p><p>If you need any different size, just give us a shout directly on email or via social media.</p>"
		},
		"weight": 500,
		"preset": {
			"material": "premium",
			"color": "ecru",
			"size": "customized",
			"pattern": "classic"
		},
		"variants": {
			"material": {
				"premium": 0,
				"deluxe": 0
			},
			"color": {
				"ecru": "0|0",
				"mustard": "0|0",
				"clementine": "0|0",
				"pumpkin": "0|0",
				"poppy": "0|0",
				"scarlet": "0|0",
				"elderberry": "0|0",
				"salmon": "0|0",
				"barbie": "0|0",
				"hot pink": "0|0",
				"chocolate": "0|0",
				"candyfloss": "0|0",
				"damson": "0|0",
				"lime": "0|0",
				"gooseberry": "0|0",
				"olive": "0|0",
				"moss": "0|0",
				"dream": "0|0",
				"spearmint": "0|0",
				"royal": "0|0",
				"navy": "0|0",
				"midnight": "0|0",
				"seal": "0|0",
				"grey": "0|0",
				"black": "0|0"
			},
			"size": {
				"customized": "0|25"
			},
			"pattern": {
				"classic": "0|0"
			}
		}
	},
	"/shop/merino-beanie/": {
		"id": 7,
		"name": "Merino Beanie",
		"price": 55,
		"path": "/shop/merino-beanie/",
		"thumbnail": "/images/products/merino-beanie/03.jpg",
		"category": "knitwear",
		"type": "beanie",
		"gallery": {
			"1": "/images/products/merino-beanie/01.jpg",
			"2": "/images/products/merino-beanie/02.jpg",
			"3": "/images/products/merino-beanie/03.jpg",
			"4": "/images/products/merino-beanie/04.jpg",
			"5": "/images/products/merino-beanie/05.jpg",
			"6": "/images/products/merino-beanie/06.jpg",
			"7": "/images/products/merino-beanie/07.jpg"
		},
		"tabs": {
			"0": {
				"title": "Samples",
				"content": "some samples text"
			},
			"1": {
				"title": "Extras",
				"content": "some description about available extras for this products"
			},
			"2": {
				"title": "care tips",
				"content": "how to care about products"
			}
		},
		"description": {
			"short": "Extremely soft and cozy, UK handicraft, luxury Beanie made from pure merino wool!",
			"long": "<p>Very warm, soft, cuddly and silky to the touch beanie. It provides very good protection against cold, and due to its delicacy it ensures superior comfort of use. I can bet you've never wear more comfortable beanie! It makes even better impression when combined with any kind of scarf. 100% hand knitted from one of the softest sheep yarns in the world.</p><p>Every beanie is tailored specially for you, so please remember to send us head measurement, or let us know if you want us to made it in 'one-size-fits-all' option.</p><p class='CalipsyContent-title'>Chose version premium(~25microns) or deluxe(~18.5microns) if you want feel extreme cozy! Also, there is 25 colors to chose from.</p><p>If you need any different size, just give us a shout directly on email or via social media.</p>"
		},
		"weight": 500,
		"preset": {
			"material": "premium",
			"color": "ecru",
			"size": "customized",
			"pattern": "classic"
		},
		"variants": {
			"material": {
				"premium": 0,
				"deluxe": 0
			},
			"color": {
				"ecru": "0|0",
				"mustard": "0|0",
				"clementine": "0|0",
				"pumpkin": "0|0",
				"poppy": "0|0",
				"scarlet": "0|0",
				"elderberry": "0|0",
				"salmon": "0|0",
				"barbie": "0|0",
				"hot pink": "0|0",
				"chocolate": "0|0",
				"candyfloss": "0|0",
				"damson": "0|0",
				"lime": "0|0",
				"gooseberry": "0|0",
				"olive": "0|0",
				"moss": "0|0",
				"dream": "0|0",
				"spearmint": "0|0",
				"royal": "0|0",
				"navy": "0|0",
				"midnight": "0|0",
				"seal": "0|0",
				"grey": "0|0",
				"black": "0|0"
			},
			"size": {
				"customized": "0|25"
			},
			"pattern": {
				"classic": "0|0"
			}
		}
	},
	"/shop/merino-infinity-scarf/": {
		"id": 8,
		"name": "Merino Infinity Scarf",
		"price": 60,
		"path": "/shop/merino-infinity-scarf/",
		"thumbnail": "/images/products/merino-infinity-scarf/01.jpg",
		"category": "knitwear",
		"type": "infinity-scarf",
		"gallery": {
			"1": "/images/products/merino-infinity-scarf/01.jpg",
			"2": "/images/products/merino-infinity-scarf/02.jpg",
			"3": "/images/products/merino-infinity-scarf/03.jpg",
			"4": "/images/products/merino-infinity-scarf/04.jpg",
			"5": "/images/products/merino-infinity-scarf/05.jpg",
			"6": "/images/products/merino-infinity-scarf/06.jpg",
			"7": "/images/products/merino-infinity-scarf/07.jpg",
			"8": "/images/products/merino-infinity-scarf/08.jpg"
		},
		"tabs": {
			"0": {
				"title": "Samples",
				"content": "some samples text"
			},
			"1": {
				"title": "Extras",
				"content": "some description about available extras for this products"
			},
			"2": {
				"title": "care tips",
				"content": "how to care about products"
			}
		},
		"description": {
			"short": "Extremely soft and cozy, UK handicraft, luxury Infinity Scarf made from pure merino wool!",
			"long": "<p>Extremely soft alternative for classic scarf! Looks great on both, a woman, and a man. Handicraft from 100% pure merino wool. Super cosy statement piece that everyone will ask you about. Great gift for your love ones. You'll be miss it every time you take it off!</p><p>The infinite scarf is made in option - 'one-size-fits-all' <small>(approx. 14x10\")</small>.</p> <p class='CalipsyContent-title'>Chose version premium(~25microns) or deluxe(~18.5microns) if you want feel extreme cozy! Also, there is 25 colors to chose from.</p><p>If you need any different size, just give us a shout directly on email or via social media.</p>"
		},
		"weight": 500,
		"preset": {
			"material": "premium",
			"color": "ecru",
			"size": "14x10inches",
			"pattern": "classic"
		},
		"variants": {
			"material": {
				"premium": 0,
				"deluxe": 0
			},
			"color": {
				"ecru": "0|0",
				"mustard": "0|0",
				"clementine": "0|0",
				"pumpkin": "0|0",
				"poppy": "0|0",
				"scarlet": "0|0",
				"elderberry": "0|0",
				"salmon": "0|0",
				"barbie": "0|0",
				"hot pink": "0|0",
				"chocolate": "0|0",
				"candyfloss": "0|0",
				"damson": "0|0",
				"lime": "0|0",
				"gooseberry": "0|0",
				"olive": "0|0",
				"moss": "0|0",
				"dream": "0|0",
				"spearmint": "0|0",
				"royal": "0|0",
				"navy": "0|0",
				"midnight": "0|0",
				"seal": "0|0",
				"grey": "0|0",
				"black": "0|0"
			},
			"size": {
				"14x10inches": "0|25"
			},
			"pattern": {
				"classic": "0|0"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/shop/productsList.json
// module id = ./src/pages/shop/productsList.json
// module chunks = 137591856104208 266772403791747 276150767547794